export default (hex: string) => {
  if (hex.length === 9) {
    const alpha = parseInt(hex.slice(-2), 16);
    return alpha / 255;
  }
  return 1;
};
